import { AvatarsGenderId, IAvatarGender, VoiceTypes } from "../../utils";

export const scenesId = ["metahumans/gradient", "metahumans/white", "metahumans/orange"];

export const avatars = ["visper/hvalena"];
export const neuralAvatarsId = ["visper/ivan", "visper/nikita", "visper/dmitry", "visper/oleg", "visper/kirill", "visper/liliya", "visper/olga", "visper/tatyana", "visper/arina", "visper/sofia"];
export const avatarsGender: AvatarsGenderId[] = [
	{ id: "visper/hvalena", gender: "female", name: "Алена", enName: "Alena" },
];

export const knownPromptKeys = new Set(["alena_prompt", "tanya_prompt", "sonya_prompt", "arina_prompt", "olga_prompt", "oleg_prompt", "dmitriy_prompt", "nikita_prompt", "ivan_prompt", "lily_prompt", "kirill_prompt" ]);

export const neuralAvatars: IAvatarGender[] = [
  
  // {
  //   value: "visper/ivan",
  //   description: "ivan",
  //   url: "",
  //   name: "ivan",
  //   gender: "male",
  //   avatarRuName: "Иван",
  //   avatarEnName: "Ivan",
  //   promptKey: "male_prompt",
  //   type: "2d",
  // },
  {
    value: "visper/kirill",
    description: "kirill",
    url: "",
    name: "kirill",
    gender: "male",
    avatarRuName: "Кирилл",
    avatarEnName: "Kirill",
    promptKey: "male_prompt",
    type: "2d",
  },
  {
    value: "visper/nikita",
    description: "nikita",
    url: "",
    name: "nikita",
    gender: "male",
    avatarRuName: "Никита",
    avatarEnName: "Nikita",
    promptKey: "male_prompt",
    type: "2d",
  },
  {
    value: "visper/dmitry",
    description: "dmitriy",
    url: "",
    name: "dmitriy",
    gender: "male",
    avatarRuName: "Дмитрий",
    avatarEnName: "Dmitriy",
    promptKey: "male_prompt",
    type: "2d",
  },
  // {
  //   value: "visper/oleg",
  //   description: "oleg",
  //   url: "",
  //   name: "oleg",
  //   gender: "male",
  //   avatarRuName: "Олег",
  //   avatarEnName: "Oleg",
  //   promptKey: "male_prompt",
  //   type: "2d",
  // },
  {
    value: "visper/liliya",
    description: "lily",
    url: "",
    name: "lily",
    gender: "female",
    avatarRuName: "Лили",
    avatarEnName: "Lily",
    promptKey: "female_prompt",
    type: "2d",
  },
  // {
  //   value: "visper/olga",
  //   description: "olga",
  //   url: "",
  //   name: "olga",
  //   gender: "female",
  //   avatarRuName: "Ольга",
  //   avatarEnName: "Olga",
  //   promptKey: "female_prompt",
  //   type: "2d",
  // },
  {
    value: "visper/tatyana",
    description: "tanya",
    url: "",
    name: "tanya",
    gender: "female",
    avatarRuName: "Таня",
    avatarEnName: "Tanya",
    promptKey: "tanya_prompt",
    type: "2d",
  },
  // {
  //   value: "visper/arina",
  //   description: "arina",
  //   url: "",
  //   name: "arina",
  //   gender: "female",
  //   avatarRuName: "Арина",
  //   avatarEnName: "Arina",
  //   promptKey: "arina_prompt",
  //   type: "2d",
  // },
  // {
  //   value: "visper/sofia",
  //   description: "sonia",
  //   url: "",
  //   name: "sonia",
  //   gender: "female",
  //   avatarRuName: "Соня",
  //   avatarEnName: "Sonia",
  //   promptKey: "sonia_prompt",
  //   type: "2d",
  // }
];

export const defaultAvatar = "visper/kirill";

export const CUSTOM_VOICES: VoiceTypes[] = [
  {
    gender: "female",
    name: "Ost",
    useCase: "apps_and_interactive_scenarios",
    voice_id: "Ost_24000",
    ttsEngine: "smartspeech",
  },
  {
    gender: "male",
    name: "Bys",
    useCase: "apps_and_interactive_scenarios",
    voice_id: "Bys_24000",
    ttsEngine: "smartspeech",
  },
];

export const ELEVEN_LABS_VOICES: string[] = [
  "alice",
  "jessica",
  "laura",
  "lily",
  "matilda",
  "sarah",
  "bill",
  "brian",
  "callum",
  "charlie",
  "chris",
  "daniel",
  "eric",
  "george",
  "liam",
  "roger",
  "will",
] as const;
